<script lang="ts">
	import PressBannerCarousel from '$lib/pressBanner/pressBannerCarousel.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			press_quotes: Array<ISbStoryData>;
			background_color: 'stone-5' | 'green-6' | 'yellow-5' | 'green-3' | 'purple-1';
		}>['content'];
	}

	let { content }: Props = $props();

	let active = $state(0);
	let carousel = $state<{ previous: () => void; next: () => void }>();

	let lightColor = $derived(['stone-5', 'green-6', 'yellow-5'].includes(content.background_color));
</script>

<div use:editable={content}>
	<PressBannerCarousel
		class="bg-{content.background_color || 'green-2'}"
		count={content.press_quotes.length}
		theme={lightColor ? 'light' : 'dark'}
		bind:this={carousel}
		bind:active
	>
		{#each content.press_quotes as quote, index}
			<Blok
				{index}
				{active}
				content={quote}
				onclick={() => {
					if (index < active) {
						carousel?.previous();
					} else if (index > active) {
						carousel?.next();
					}
					active = index;
				}}
				color={lightColor ? 'brown-2' : 'stone-5'}
			/>
		{/each}
	</PressBannerCarousel>
</div>
